// Libs
import { styled } from '@mui/material';
// Components, Layouts, Pages
// Others
// Styles, images, icons

type Props = {
  isCollapse: boolean;
};

const SidebarContainer = styled('section', {
  shouldForwardProp: (prop) => prop !== 'isCollapse',
})<Props>(({ theme, isCollapse }) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  width: isCollapse ? '82px' : '240px',
}));

export default SidebarContainer;
